import { z } from "zod/v4"
import { CreatedAt, FirestoreTimestampSchema } from "./system"
import { LiveCommentIdSchema, LiveIdSchema, SpaceKeySchema, UserIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"

export const LiveViewerDocumentBody = z.object({
  space_key: SpaceKeySchema,
  live_id: LiveIdSchema,
  user_id: UserIdSchema,
  new_user_live_comment_id: LiveCommentIdSchema,
  updated_at: FirestoreTimestampSchema.nullable(),
  created_at: FirestoreTimestampSchema.nullable(),
  /** 「静かに参加」で入室したかどうか。true の場合、入室コメントに名前を表示しない。 */
  is_silent: z.boolean().optional(),
  /** 視聴者がライブから明示的に離脱した時刻。null の場合は離脱していない（または left_at 未対応のクライアント）。 */
  left_at: FirestoreTimestampSchema.nullable().optional(),
})

export type LiveViewerDocumentBody = z.infer<typeof LiveViewerDocumentBody>

export class LiveViewerDocuments {

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): LiveViewerDocumentBody | null {
    const data = doc?.data()
    if (data === undefined) {
      return null
    }

    return {
      space_key: data["space_key"],
      live_id: data["live_id"],
      user_id: data["user_id"],
      new_user_live_comment_id: data["new_user_live_comment_id"],
      updated_at: data["updated_at"],
      created_at: data["created_at"],
      is_silent: data["is_silent"] ?? false,
      left_at: data["left_at"] ?? null,
    }
  }
}

export const LiveViewerLogDocumentBody = z.object({
  space_key: SpaceKeySchema,
  live_id: LiveIdSchema,
  user_id: UserIdSchema,
  created_at: CreatedAt,
})

export type LiveViewerLogDocumentBody = z.infer<typeof LiveViewerLogDocumentBody>
